import { render, staticRenderFns } from "./check-confirm.vue?vue&type=template&id=51dfe46e&scoped=true"
import script from "./check-confirm.vue?vue&type=script&lang=ts"
export * from "./check-confirm.vue?vue&type=script&lang=ts"
import style0 from "./check-confirm.vue?vue&type=style&index=0&id=51dfe46e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dfe46e",
  null
  
)

export default component.exports